import OrganizationsTable from './OrganizationsTable'
export default OrganizationsTable


// WEBPACK FOOTER //
// ./src/components/ChannelTabs/BookingTab/MappingTabs/OrganizationTab/OrganizationTable/index.js